import { endOfDay, startOfDay, startOfMonth, subMonths } from 'date-fns';

export function getDefaultPeriodMinDate(): Date {
  return startOfDay(startOfMonth(subMonths(new Date(), 1)));
}

export function getDefaultPeriodMaxDate(): Date {
  return endOfDay(new Date());
}
